<template>

    <bottom-sheet ref="bottomsheet">

        <div class="bsfn__container">

            <h1 class="bsfn__title">{{ $t('settings_sure_disconnect') }}</h1>

            <button class="btn btn-big btn-red bsfn__btn-red" @click="disconnect">{{ $t('settings_disconnect') }}</button>

            <button class="btn btn-big bsfn__btn-white" @click="close">{{ $t('settings_cta_cancel_delete') }}</button>

        </div>

    </bottom-sheet>

</template>

<script>

import Auth from '@/modules/auth'

import BottomSheet from '@/components/bottomSheet/BottomSheet'

export default {

    name: 'bottom-sheet-fetch-notifications',

    components: {BottomSheet},

    data() {
        return {
            show: false
        }
    },

    methods: {

        open() {
            this.$refs.bottomsheet.open()
        },

        close() {
            this.$refs.bottomsheet.close()
            this.$emit('close')
        },

        disconnect() {
            Auth.disconnect()

        }
    }

}

</script>

<style lang="scss" scoped>

.bsfn {
    &__container {
        width: 100%;
        padding: 0 24px 32px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        color: $midnight;
        @media screen and (min-width: $above-tablet-length) {
            padding: 24px;
        }
    }

    &__title {
        width: 100%;
        font-size: 24px;
        line-height: 1.17;
        text-align: center;
        color: $charcoal;
        font-weight: bold;
    }

    &__btn-red {
        margin-top: 24px;
        padding: 0 24px;
    }

    &__btn-white {
        margin-top: 16px;
        padding: 0 24px;
        background-color: white;
        color: $charcoal;
        border: solid 4px $timberwolf;
    }
}

</style>
